import { authenticatedGet, authenticatedPut, authenticatedDelete } from '../utils/apiUtils';
import { USERS_URL } from '../api-config';
import { getCachedData } from './cacheService';

export const getUsers = () => authenticatedGet(USERS_URL);

export const getUserById = (userId) => authenticatedGet(`${USERS_URL}/${userId}`);

export const updateUser = (userId, userData) => authenticatedPut(`${USERS_URL}/${userId}`, userData);

export const deleteUser = async (userId) => {
  const cachedPledges = getCachedData(`pledges_for_user_${userId}`);
  if (cachedPledges?.data?.length > 0) {
    throw new Error('Cannot delete user with active pledges');
  }
  return authenticatedDelete(`${USERS_URL}/${userId}`);
};